import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-file',
  template: '<p>Iniciando download...</p>',
})
export class DownloadFileComponent implements OnInit {
  ngOnInit(): void {
    const link = document.createElement('a');
    link.href = '/assets/OrbisLoader.bin';
    link.download = 'OrbisLoader.bin';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}